var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { HDSBreadcrumb, HDSBreadcrumbItem, } from "@here/hds-react-components/Breadcrumb";
import { HDSButton } from "@here/hds-react-components/Button";
import { HDSIcon } from "@here/hds-react-components/Icon";
import { HDSTooltip } from "@here/hds-react-components/Tooltip";
import "../../pages/Overview/overview.scss";
import "./mapCollectionDetails.scss";
import "../internalToolsPage/internalToolsPage.scss";
import { setMapCollectionSelected } from "../../store/reducers/appSlice";
import SearchBox from "../../components/searchBox/SearchBox";
import DropDown from "../../components/dropDown/DropDown";
import { setIsSortClicked } from "../../store/reducers/venuesSlice";
import { INDOOR_MAP } from "../../store/common/constants";
import { COLLECTIONS, listDrop, MAP_COLLECTION_TABLE_GEN_HEADERS, valuesList, } from "./constants";
import { Table, Text } from "../../generic-components/Table";
import { Pagination, } from "../../generic-components/Pagination";
import utils from "../../store/helpers/indoorHelper";
import { NOTIFICATION_VARIANT } from ".././../store/common/constants";
var MapCollectionDetails = function (_a) {
    var _b, _c;
    var mapDetailsList = _a.mapDetailsList, onSearchChange = _a.onSearchChange, onSortChange = _a.onSortChange, searchText = _a.searchText, sortText = _a.sortText;
    var dispatch = useDispatch();
    var history = useHistory();
    var _d = useState(1), pageNumber = _d[0], setPageNumber = _d[1];
    var _e = useState(INDOOR_MAP.MAP_PER_PAGE), mapsPerPage = _e[0], setMapsPerPage = _e[1];
    var mapsVisited = pageNumber * mapsPerPage;
    var totalCollectionItem = mapDetailsList === null || mapDetailsList === void 0 ? void 0 : mapDetailsList.maps.length;
    var protocol = document.location.protocol;
    var hostname = document.location.hostname.includes("platform.here.com")
        ? "platform.here.com"
        : "platform.in.here.com";
    var copyIconStyle = {
        "--hds-icon-color": "var(--hds-action)",
    };
    var iconStyle = {
        "--hds-icon-color": "var(--hds-purple-600)",
    };
    var backToMapCollection = function () {
        history.push({
            pathname: "/",
            search: window.location.search,
            state: { isMapCollectionDetails: false },
        });
        dispatch(setMapCollectionSelected(true));
    };
    var copyMapId = function (id) {
        navigator.clipboard.writeText(id);
        utils.notify("", COLLECTIONS.COPY_MAP_ID.LABEL, 3, NOTIFICATION_VARIANT.CONFIRM, "solid");
    };
    var handlePageChange = function (e) {
        var _a = e.detail, page = _a.page, itemsPerPage = _a.itemsPerPage;
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setPageNumber(page);
        // only update mapsPerPage when user updates page dropdown
        if (itemsPerPage !== mapsPerPage) {
            setMapsPerPage(itemsPerPage);
        }
    };
    //TODO: to remove the unnecessary divs from the collectionname element.
    var cells = {
        collectionName: function (item) { return (_jsxs("div", __assign({ className: "collectionContainer" }, { children: [_jsx("div", __assign({ className: "iconDetails" }, { children: _jsxs("div", __assign({ style: { height: "50px" } }, { children: [_jsx("div", __assign({ className: "ellipse" }, { children: " " })), _jsx("div", __assign({ className: "mapIcon" }, { children: _jsx(HDSIcon, { name: "map-view", category: "map-view", size: "24px", style: iconStyle }) }))] })) })), _jsx(Text, { value: item === null || item === void 0 ? void 0 : item.mapName, classes: "collectionNameDetails" })] }))); },
        mapUUID: function (item) { return (_jsxs("div", __assign({ className: "collectionIdDetails" }, { children: [_jsxs("div", __assign({ id: item === null || item === void 0 ? void 0 : item.mapid, className: "collectionUrl", onClick: function () {
                        copyMapId(item === null || item === void 0 ? void 0 : item.mapid);
                    } }, { children: [_jsx(HDSButton, __assign({ variant: "link" }, { children: COLLECTIONS.VIEW.LABEL })), _jsx(HDSIcon, { name: "copy", category: "file", size: "16px", style: copyIconStyle })] })), _jsx(HDSTooltip, __assign({ trigger: "#".concat(item === null || item === void 0 ? void 0 : item.mapid), placement: "right" }, { children: item === null || item === void 0 ? void 0 : item.mapid }))] }))); },
        city: function (item) { return (_jsx(Text, { value: item === null || item === void 0 ? void 0 : item.mapcity, classes: "collectionCityDetails" })); },
        viewDetails: function (item) {
            var url = "\n      ".concat(protocol, "//").concat(hostname, "/indoor-map-creator/?cat=").concat(mapDetailsList === null || mapDetailsList === void 0 ? void 0 : mapDetailsList.collectionHrn, "&layerId=").concat(mapDetailsList === null || mapDetailsList === void 0 ? void 0 : mapDetailsList.latestSnapshot, "&mapId=").concat(item === null || item === void 0 ? void 0 : item.mapid);
            return (_jsx("div", __assign({ className: "collectionViewDetails" }, { children: _jsx("a", __assign({ href: url, id: "map-update", target: "_blank", rel: "noreferrer" }, { children: _jsx(HDSButton, __assign({ variant: "secondary", type: "button", size: "small", width: "103px" }, { children: COLLECTIONS.VIEW.LABEL })) })) })));
        },
    };
    //params on the basis of which the list will be sorted
    var sortByParams = {
        Name: "mapName",
        City: "mapcity",
    };
    var sortList = function (sortByMap) {
        var sortBy = sortByParams[sortByMap];
        dispatch(setIsSortClicked(true));
        onSortChange(sortBy);
    };
    var rows = useMemo(function () {
        var _a;
        var rowItems = (_a = mapDetailsList.maps) === null || _a === void 0 ? void 0 : _a.slice((pageNumber - 1) * mapsPerPage, pageNumber * mapsPerPage);
        return rowItems;
    }, [mapsVisited, mapsPerPage, mapDetailsList.maps]);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "breadCrumbContainer" }, { children: _jsxs(HDSBreadcrumb, { children: [_jsx(HDSBreadcrumbItem, __assign({ style: { display: "flex", justifyContent: "center" } }, { children: _jsx("a", __assign({ onClick: backToMapCollection }, { children: COLLECTIONS.INTERNAL_TABS.LABEL })) })), _jsx(HDSBreadcrumbItem, __assign({ active: true, style: { display: "flex", justifyContent: "center" } }, { children: mapDetailsList.collectionName }))] }) })), _jsx("div", __assign({ className: "trackingMapsHeader" }, { children: _jsx("div", __assign({ className: "trackingMapsHeading" }, { children: mapDetailsList.collectionName })) })), _jsxs("div", __assign({ className: "collectionSubheading" }, { children: [(_b = mapDetailsList === null || mapDetailsList === void 0 ? void 0 : mapDetailsList.maps) === null || _b === void 0 ? void 0 : _b.length, " maps", _jsxs("div", __assign({ className: "searchSortContainer" }, { children: [_jsx(SearchBox, { onChange: function (s) {
                                    onSearchChange(s);
                                }, searchText: searchText }), _jsx("div", __assign({ style: {
                                    pointerEvents: ((_c = mapDetailsList === null || mapDetailsList === void 0 ? void 0 : mapDetailsList.maps) === null || _c === void 0 ? void 0 : _c.length) === 0 ? "none" : "auto",
                                } }, { children: _jsx(DropDown, { itemList: listDrop, displayListItemIcon: true, onChange: sortList, value: valuesList[sortText] ? valuesList[sortText] : "", "data-cy": "sort-dropdown", id: "sort-dropdown" }) }))] }))] })), _jsx("div", __assign({ className: "collectionBox" }, { children: _jsx(Table, { columns: MAP_COLLECTION_TABLE_GEN_HEADERS, cells: cells, rows: rows }) })), _jsx("div", __assign({ className: "paginationContainer" }, { children: _jsx(Pagination, { pageInputType: "input", totalItems: totalCollectionItem, itemsPerPage: mapsPerPage, page: pageNumber, onChange: handlePageChange, textAfterItemsPerPage: "{itemsFrom}-{itemsTo} of {totalItems} items", textAfterPage: "of {totalPages}" }) }))] }));
};
export default MapCollectionDetails;
